import { createAction } from '@reduxjs/toolkit';
export const UPDATE_ANALYTIC_DOMAIN_USER = 'UPDATE_ANALYTIC_DOMAIN_USER';
export const updateAnalyticDomainUserAction = createAction(UPDATE_ANALYTIC_DOMAIN_USER);